import React from 'react';
import NeonDivider from './NeonDivider';
import cateringData from '../data/catering.json';

const CateringSection = () => {
  return (
    <section id="catering" className="py-20 px-4 bg-gradient-to-b from-black via-black/95 to-black">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-logoSans text-ivory mb-4">
            CATERING
          </h2>
          <p className="text-gray text-lg max-w-2xl mx-auto">
            Bring Billy's legendary wings to your event. Perfect for corporate gatherings, 
            parties, and celebrations where flavor matters.
          </p>
        </div>

        <NeonDivider color="neonBlue" />

        <div className="grid lg:grid-cols-3 gap-8 mb-16">
          {/* Small Gatherings */}
          <div className="p-8 border border-neonBlue/20 rounded-xl bg-black/30 backdrop-blur-sm hover:border-neonBlue/40 transition-all duration-200">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-neonBlue/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-neonBlue" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-logoSans text-ivory mb-2">{cateringData.smallGatherings.title.toUpperCase()}</h3>
              <p className="text-neonBlue font-semibold">{cateringData.smallGatherings.subtitle}</p>
            </div>
            <ul className="space-y-3 text-gray text-sm mb-6">
              {cateringData.smallGatherings.features.map((feature, index) => (
                <li key={index}>• {feature}</li>
              ))}
            </ul>
            <div className="text-center">
              <p className="text-2xl font-bold text-neonBlue mb-4">From ${cateringData.smallGatherings.priceFrom}</p>
              <a
                href="tel:+14162659223"
                className="inline-flex items-center bg-neonBlue text-black px-6 py-3 rounded-lg font-semibold
                           shadow-neonBlue hover:animate-flicker hover:-translate-y-0.5 
                           transition-all duration-200 w-full justify-center"
              >
                Call to Order
              </a>
            </div>
          </div>

          {/* Parties & Corporate Events */}
          <div className="p-8 border border-neonRed/20 rounded-xl bg-black/30 backdrop-blur-sm hover:border-neonRed/40 transition-all duration-200 relative">
            {cateringData.partiesAndCorporate.popular && (
              <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                <span className="bg-neonRed text-white px-3 py-1 rounded-full text-xs font-semibold">POPULAR</span>
              </div>
            )}
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-neonRed/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-neonRed" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>
              <h3 className="text-xl font-logoSans text-ivory mb-2">{cateringData.partiesAndCorporate.title.toUpperCase()}</h3>
              <p className="text-neonRed font-semibold">{cateringData.partiesAndCorporate.subtitle}</p>
            </div>
            <ul className="space-y-3 text-gray text-sm mb-6">
              {cateringData.partiesAndCorporate.features.map((feature, index) => (
                <li key={index}>• {feature}</li>
              ))}
              <li>• {cateringData.partiesAndCorporate.notice}</li>
            </ul>
            <div className="text-center">
              <p className="text-2xl font-bold text-neonRed mb-4">From ${cateringData.partiesAndCorporate.basePrice}</p>
              <a
                href="mailto:catering@billyswingco.com"
                className="inline-flex items-center bg-neonRed text-white px-6 py-3 rounded-lg font-semibold
                           shadow-neonRed hover:animate-flicker hover:-translate-y-0.5 
                           transition-all duration-200 w-full justify-center"
              >
                Email Quote
              </a>
            </div>
          </div>

          {/* Large Events */}
          <div className="p-8 border border-neonBlue/20 rounded-xl bg-black/30 backdrop-blur-sm hover:border-neonBlue/40 transition-all duration-200">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-neonBlue/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-neonBlue" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" />
                </svg>
              </div>
              <h3 className="text-xl font-logoSans text-ivory mb-2">{cateringData.largeEvents.title.toUpperCase()}</h3>
              <p className="text-neonBlue font-semibold">{cateringData.largeEvents.subtitle}</p>
            </div>
            <ul className="space-y-3 text-gray text-sm mb-6">
              {cateringData.largeEvents.features.map((feature, index) => (
                <li key={index}>• {feature}</li>
              ))}
              <li>• {cateringData.largeEvents.notice}</li>
            </ul>
            <div className="text-center">
              <p className="text-2xl font-bold text-neonBlue mb-4">Custom Quote</p>
              <a
                href="mailto:catering@billyswingco.com"
                className="inline-flex items-center border-2 border-neonBlue text-neonBlue px-6 py-3 rounded-lg 
                           font-semibold hover:bg-neonBlue hover:text-black hover:shadow-neonBlue 
                           hover:-translate-y-0.5 transition-all duration-200 w-full justify-center"
              >
                Get Custom Quote
              </a>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-2xl md:text-3xl font-logoSans text-ivory mb-6">
              WHY CHOOSE BILLY'S CATERING?
            </h3>
            <div className="space-y-4">
              {cateringData.whyChooseBillys.map((feature, index) => (
                <div key={index} className="flex gap-4">
                  <div className="w-6 h-6 bg-neonRed rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-ivory font-semibold mb-1">{feature.title}</h4>
                    <p className="text-gray text-sm">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="space-y-6">
            <div className="p-6 border border-gray/20 rounded-xl bg-black/30 backdrop-blur-sm">
              <h4 className="text-ivory font-logoSans text-lg mb-4">Ready to Order?</h4>
              <div className="space-y-3">
                <a
                  href="tel:+14162659223"
                  className="flex items-center gap-3 text-gray hover:text-neonBlue transition-colors duration-200"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  <span>(416) 265-9223</span>
                </a>
                <a
                  href="mailto:catering@billyswingco.com"
                  className="flex items-center gap-3 text-gray hover:text-neonRed transition-colors duration-200"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <span>catering@billyswingco.com</span>
                </a>
              </div>
            </div>

            <div className="p-6 border border-neonRed/20 rounded-xl bg-black/30 backdrop-blur-sm">
              <h4 className="text-ivory font-logoSans text-lg mb-2">Planning Ahead?</h4>
              <p className="text-gray text-sm mb-4">{cateringData.advanceOrderPromo.description}</p>
              <div className="text-neonRed font-semibold">Use code: {cateringData.advanceOrderPromo.code}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CateringSection; 